import { useMemo } from 'react';

import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import type { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';

import { EMPTY_STRING } from '@e-socna/empty';

import { formatDirectorName } from './utils/format-director-name.util';
import type { OrganizationSearchDirectorPersonnePhysique } from './types/organization-search-result.type';

interface Row {
  readonly id: number;
  readonly name: string;
  readonly qualite: string;
}

const columns: readonly GridColDef<Row>[] = [
  { field: 'name', headerName: 'Nom', flex: 1 },
  { field: 'qualite', headerName: 'Qualité', flex: 1 },
];

interface Props {
  readonly directors: readonly OrganizationSearchDirectorPersonnePhysique[];
  readonly onRowSelectionModelChange: (model: GridRowSelectionModel) => void;
  readonly rowSelectionModel: GridRowSelectionModel;
}

export const DirectorsSelectionGrid = ({
  directors,
  onRowSelectionModelChange,
  rowSelectionModel,
}: Readonly<Props>) => {
  const rows: readonly Row[] = useMemo(
    () =>
      directors.map((director, index) => ({
        id: index,
        name: formatDirectorName(director),
        qualite: director.qualite ?? EMPTY_STRING,
      })),
    [directors],
  );

  return (
    <Box sx={{ width: '100%', minWidth: { sm: 400 } }}>
      <DataGrid
        autoHeight
        checkboxSelection
        columns={[...columns]}
        disableColumnMenu
        disableRowSelectionOnClick
        hideFooter
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        rows={[...rows]}
      />
    </Box>
  );
};
